import { actionCreatorFactory } from 'typescript-fsa';
import { SelectedId } from './multiSelectSidebar.interface';

export namespace MultiSelectSidebarAction {
  const actionCreator = actionCreatorFactory('MultiSelectSidebar');

  export const toggleMultiEditMode = actionCreator('TOGGLE_MULTI_EDIT_MODE');
  export const setSelection = actionCreator<{ ids: SelectedId[]; rows: unknown[] }>('SET_SELECTION');
  export const clearSelection = actionCreator('CLEAR_SELECTION');
  export const openBulkEditSidebar = actionCreator('OPEN_BULK_EDIT_SIDEBAR');
  export const closeBulkEditSidebar = actionCreator('CLOSE_BULK_EDIT_SIDEBAR');
  export const destroy = actionCreator('DESTROY');
}
